import { useEffect, useState } from 'react';
import './css/Entidade.css';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import TableContainer from './components/TableContainer';
import Pagination10 from './components/Pagination10';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ConfirmModal from './components/modals/ConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ResponsiveShadow from './components/ResponsiveShadow';
import usePagination10 from './components/hooks/usePagination10';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import EntidadeModal from './components/modals/EntidadeModal';
import VinculosEntidadeModal from './components/modals/VinculosEntidadeModal';
import DataTable from './components/DataTable';

function Entidades() {
  const [Entidades, setEntidades] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [atualizar, setAtualizar] = useState([]);
  const [entidadeSelecionada, setEntidadeSelecionada] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showVinculosModal, setShowVinculosModal] = useState(false);
  const [vinculosCount, setVinculosCount] = useState({});
  const token = localStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();

  useEffect(() => {
    if (!token) {
      navigate('/');
    }
    setLoading(true);
    axios
      .get(`${API_BASE_URL.ENTIDADE}/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        setEntidades(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter entidades:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [atualizar]);

  useEffect(() => {
    if (token && Entidades.length > 0) {
      axios
        .get(`${API_BASE_URL.VINCULO}/all`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          const countMap = {};
          if (Array.isArray(result.data)) {
            result.data.forEach(v => {
              countMap[v.idEntidade] = (countMap[v.idEntidade] || 0) + 1;
            });
          }
          setVinculosCount(countMap);
        })
        .catch(error => {
          console.error('Erro ao obter vínculos:', error);
        });
    }
  }, [Entidades, token, atualizar]);

  function handleDelete(c) {
    showConfirmModal('delete', () => handleConfirmDelete(c));
  }

  function handleNew() {
    setEntidadeSelecionada(null);
    setShowModal(true);
  }

  function handleEdit() {
    if (!entidadeSelecionada) return;
    setShowModal(true);
  }

  function handleVinculos() {
    if (!entidadeSelecionada) return;
    setShowVinculosModal(true);
  }

  function handleCloseModal() {
    setShowModal(false);
    setEntidadeSelecionada(null);
  }

  function handleSaveSuccess() {
    setAtualizar(prev => !prev);
    setEntidadeSelecionada(null);
  }

  function handleConfirmDelete(c) {
    axios
      .get(`${API_BASE_URL.VINCULO}/exists_entidade/` + c.idEntidade, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        if (result.data.exists) {
          showDefaultModal(
            'error',
            'Esta Entidade/Entidade possui vínculos e não pode ser excluído. Exclua os vínculos antes de tentar novamente.'
          );
        } else {
          axios
            .delete(`${API_BASE_URL.ENTIDADE}/delete/` + c.idEntidade, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then(() => {
              setAtualizar(prev => !prev);
            });
        }
      })
      .catch(error => {
        console.error('Erro ao verificar vínculos:', error);
        showDefaultModal('error', 'Erro ao excluir o registro!');
        setTimeout(() => navigate('/'), 0);
      });
  }

  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const entidadesFiltrados = Array.isArray(Entidades)
    ? Entidades.filter(c => {
        const normalizedBusca = normalizeString(filtro);
        return (
          normalizeString(c.nome || '').includes(normalizedBusca) ||
          normalizeString(c.cnpj || '').includes(normalizedBusca) ||
          normalizeString(c.logrCidade || c.municipio || '').includes(
            normalizedBusca
          ) ||
          normalizeString(c.logrUf || c.uf || '').includes(normalizedBusca)
        );
      })
    : [];

  // Paginação dos entidades filtrados
  const totalItems = entidadesFiltrados.length;
  const { setPagination } = usePagination10(totalItems, 20);
  const selectedEntidades = entidadesFiltrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Entidades Cadastradas" icon="bi-building" />
        <PageContent>
          <div className="d-flex flex-column flex-lg-row justify-content-lg-between gap-2 mb-2 align-items-start align-items-lg-center">
            <div className="botao-grid-2col">
              <button
                className="btn btn-success btn-sm botao-igual"
                onClick={handleNew}
                title="Cadastrar nova entidade"
              >
                <i className="bi bi-plus-circle me-1"></i>
                Novo
              </button>
              <button
                className="btn btn-primary btn-sm botao-igual"
                disabled={!entidadeSelecionada}
                onClick={handleEdit}
                title="Editar entidade selecionada"
              >
                <i className="bi bi-pencil me-1"></i>
                Editar
              </button>
              <button
                className="btn btn-danger btn-sm botao-igual"
                disabled={!entidadeSelecionada}
                onClick={() => handleDelete(entidadeSelecionada)}
                title="Excluir entidade selecionada"
              >
                <i className="bi bi-trash me-1"></i>
                Excluir
              </button>
              <button
                className="btn btn-info btn-sm botao-igual"
                disabled={!entidadeSelecionada}
                onClick={handleVinculos}
                title="Listar usuários vinculados"
              >
                <i className="bi bi-link-45deg me-1"></i>
                Vínculos
              </button>
            </div>
            <div className="mt-2 mt-lg-0">
              <div className="input-group input-group-sm">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Buscar por CNPJ, Nome ou Cidade"
                  value={filtro}
                  onChange={e => setFiltro(e.target.value.toUpperCase())}
                />
              </div>
            </div>
          </div>

          <TableContainer isLoading={isLoading}>
              <DataTable style={{ fontSize: '0.8rem' }} head={
                <tr>
                  <th scope="col" className="px-2 d-none d-md-table-cell">
                    CNPJ
                  </th>
                  <th scope="col" className="px-2">
                    Nome
                  </th>
                  <th scope="col" className="px-2">
                    Cidade
                  </th>
                  <th scope="col" className="px-2">
                    UF
                  </th>
                  <th scope="col" className="px-2 text-center">
                    Qtde Vínculos
                  </th>
                </tr>}>
              <tbody>
                {selectedEntidades.map(c => (
                    <tr
                      key={c.idEntidade}
                      className={
                        entidadeSelecionada &&
                        entidadeSelecionada.idEntidade === c.idEntidade
                          ? 'table-primary'
                          : ''
                      }
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (
                          entidadeSelecionada &&
                          entidadeSelecionada.idEntidade === c.idEntidade
                        ) {
                          setEntidadeSelecionada(null);
                        } else {
                          setEntidadeSelecionada(c);
                        }
                      }}
                    >
                      <td className="px-2 d-none d-md-table-cell">{c.cnpj}</td>
                      <td className="px-2">{c.nome}</td>
                      <td className="px-2">
                        {c.logrCidade || c.municipio || '-'}
                      </td>
                      <td className="px-2">{c.logrUf || c.uf || '-'}</td>
                      <td className="px-2 text-center">{vinculosCount[c.idEntidade] || 0}</td>
                    </tr>
                  ))}
              </tbody>
            </DataTable>
            </TableContainer>
        </PageContent>
        <div style={{ padding: '0.5rem 1rem', borderTop: '1px solid rgba(0,0,0,0.1)', backgroundColor: '#f8f9fa' }}>
          <Pagination10 {...setPagination} />
        </div>
        {showModal && (
          <EntidadeModal
            show={showModal}
            entidade={entidadeSelecionada}
            onClose={handleCloseModal}
            onSave={handleSaveSuccess}
          />
        )}
        <ConfirmModal {...setConfirmModal} />
        <DefaultModal {...setDefaultModal} />
        <VinculosEntidadeModal
          show={showVinculosModal}
          entidade={entidadeSelecionada}
          onClose={() => setShowVinculosModal(false)}
        />
      </ResponsiveShadow>
    </Layout>
  );
}

export default Entidades;
